import {useField} from "formik";
import ErrorMessage from "./ErrorMessage";
import classnames from "classnames";
import {mdiEyeOffOutline, mdiEyeOutline} from "@mdi/js";
import Icon from "@mdi/react";
import {useState} from "react";

const TextField = ({label, className, type, ...props}) => {
    const [field, meta] = useField(props);
    const [inputType, setInputType] = useState(type);

    const formControlClassName = classnames(
        'form-control',
        className,
        {'form-control--invalid': meta.touched && meta.error},
    );

    const toggleInputType = () => {
        setInputType(inputType === 'password' ? 'text' : 'password');
    }

    return (
        <div className="mb20">
            <label className="form-label">{label}</label>

            <div className="form-control__wrapper">
                {!props.disabled && type === "password" &&
                <div className="form-control__icon" onClick={() => toggleInputType()}>
                    <Icon path={inputType === "password" ? mdiEyeOutline : mdiEyeOffOutline} size="20px"/>
                </div>
                }

                <input
                    {...field}
                    {...props}
                    type={inputType}
                    className={formControlClassName}
                    value={field.value || ''}
                />
            </div>

            <ErrorMessage {...props}/>
        </div>
    );
};

export default TextField;